var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"100px"}},[_c('h1',[_vm._v("No Home yet, click on AWS icon in order to chose aws test")])])}]

export { render, staticRenderFns }